import { render, staticRenderFns } from "./InstructionFigure.vue?vue&type=template&id=1565cb79&"
import script from "./InstructionFigure.vue?vue&type=script&lang=js&"
export * from "./InstructionFigure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports